import { render, staticRenderFns } from "./EventAvailabilityCardStaffInstructionsDialog.vue?vue&type=template&id=04d73906&scoped=true"
import script from "./EventAvailabilityCardStaffInstructionsDialog.vue?vue&type=script&lang=js"
export * from "./EventAvailabilityCardStaffInstructionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d73906",
  null
  
)

export default component.exports